import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NavigateBefore, NavigateNext } from '@material-ui/icons';

// Components
import { Fab } from '../Button';

// Styles
import { slideDown } from '../../styles/animations';

const propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  onChange: PropTypes.func,
  id: PropTypes.string
};

const defaultProps = {
  children: []
};

const CarouselWrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const CarouselBlock = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .carousel-arrow {
    position: absolute;
    z-index: 1;
    cursor: pointer;
    &.carousel-left {
      left: 0;
    }
    &.carousel-right {
      right: 0;
    }
    button{
      background-color: rgba(255, 255, 255, 0.2);
      border: none;
      backdrop-filter: blur(1rem);
      transition: all 0.3s ease;
      &:hover {
          background-color: #559eff;
      }
    }
    svg{
      width: 4rem;
      height: 4rem;
    }
  }
`;

const CarouselContainer = styled('div')`
  display: inline-flex;
  position: relative;
  left: 0px;
  transition: all 550ms cubic-bezier(0.02, 0.01, 0.47, 1);
	.carousel-item{
		animation-name: ${slideDown};
		animation-duration: 0.5s;
	}
`;

const CarouselItem = styled.div`
  display: inline-block;
  margin-right: 1.5rem;
  &:first-child{
    margin-left: 0;
  }
`;

const Carousel = (props) => {
  const { children, onChange, id } = props;
  const [state, setState] = useState({
    carouselItems: [],
    totalSlides: 0,
    viewWidth: 0,
    currentSlide: 1
  });

  const { carouselItems, totalSlides, viewWidth, currentSlide } = state;
  let carouselWrapper = null;
  let carouselContainer = null;

  const setupCarousel = (items) => {
    let carouselItemsArr = [];
    if (items && items.length) {
      carouselItemsArr = React.Children.map(items, (child) => {
        return child ? React.cloneElement(child, {}) : null;
      });
    }
    setState({
      ...state,
      carouselItems: carouselItemsArr
    });
  };

  useEffect(() => {
    setupCarousel(children);
  }, [children]);

  const styleCarousel = () => {
    const wrapperWidth = carouselWrapper.offsetWidth;
    const containerWidth = carouselContainer.offsetWidth;
    const childCount = carouselContainer.childElementCount;
    if (containerWidth && childCount) {
      const perChildWidth = containerWidth / childCount;
      const slidePerView = Math.floor(wrapperWidth / perChildWidth);
      const slideCount = Math.ceil(childCount / slidePerView);
      const slideViewWidth = slidePerView * perChildWidth;
      if (totalSlides !== slideCount) {
        setState({
          ...state,
          totalSlides: slideCount,
          viewWidth: slideViewWidth
        });
      }
    }
  };

  useEffect(() => {
    styleCarousel();
  });

  const carouselAction = (action) => {
    // eslint-disable-next-line radix
    const containerLeft = parseInt(carouselContainer.style.left);
    let slide = null;
    switch (action) {
    case 'left':
      if (currentSlide > 1) {
        let left = 0;
        if (containerLeft) {
          left = containerLeft;
        }
        left += viewWidth;

        carouselContainer.style.left = left + 'px';
        slide = state.currentSlide - 1;
      }
      break;
    case 'right':
      if (currentSlide < totalSlides) {
        let left = 0;
        if (containerLeft) {
          left = containerLeft;
        }
        left -= viewWidth;

        carouselContainer.style.left = left + 'px';
        slide = state.currentSlide + 1;
      }
      break;
    default:
      // eslint-disable-next-line no-console
      console.log('default');
    }

    setState({
      ...state,
      currentSlide: slide
    });

    if (onChange) {
      onChange(action, totalSlides, slide);
    }
  };

  return (
    <CarouselWrapper
      className={'carousel-wrapper ' + id}
      ref={(wrapper) => {
        carouselWrapper = wrapper;
      }}
    >
      <CarouselBlock className="carousel-block">
        {currentSlide > 1 ? (
          <div className="carousel-arrow carousel-left">
            <Fab
              role="presentation"
              onClick={() => {
                carouselAction('left');
              }}
              icon={<NavigateBefore />}
            />
          </div>
        ) : null}
        {currentSlide < totalSlides ? (
          <div className="carousel-arrow carousel-right">
            <Fab
              role="presentation"
              onClick={() => {
                carouselAction('right');
              }}
              icon={<NavigateNext />}
            />
          </div>
        ) : null}
        <CarouselContainer
          className="carousel-container"
          ref={(container) => {
            carouselContainer = container;
          }}
        >
          {carouselItems.map((item) => (
            <CarouselItem
              className="carousel-item"
              key={item.props.id}
            >
              {item}
            </CarouselItem>
          ))}
        </CarouselContainer>
      </CarouselBlock>
    </CarouselWrapper>
  );
};

export default Carousel;

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;
